/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert as RAlert } from 'reactstrap';

// eslint-disable-next-line react/prefer-stateless-function
class Alert extends React.Component {
  render() {
    return <RAlert {...this.props}>{this.props.children}</RAlert>;
  }
}

Alert.propTypes = {
  children: PropTypes.any,
};

export default Alert;
